<template>
  <div class="mt-3 relative">
    <MBScan
      :doc-type="docType"
      should-start-scan
      @results="onScanResult"
      @close="sendCloseMessage" />
  </div>
</template>

<script>
import MBScan from '@/mixins/MBScan'
import iframeCommsMixin from '@/mixins/iframeCommsMixin'

export default {
  name: 'Scan',
  components: { MBScan },
  mixins: [iframeCommsMixin],
  computed: {
    docType() {
      return this.$store.state.embedTokenData?.document || ''
    }
  }
}
</script>
